export default __webpack_public_path__ + "static/media/mojGrad-ikona-prijedlog.3464fd46.svg";